import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'glamorous'
import { noop } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { graphql } from 'react-apollo'

import { $ } from 'utils'
import { HeaderRow, PhotoListSelector, Loader, FlatButton } from 'components'
import { PERSONS } from 'queries'

import PanelSearchInput from './PanelSearchInput'

const AnimatedContainer = styled.div({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  background: '#fff',
  zIndex: 2,
  transform: 'translateX(100%)',
  animation: 'var(--animationSlideIn)',
}, ({ shown }) => !shown && ({
  animation: 'var(--animationSlideOut)',
}), 'VerifyPanel')

const InputContainer = styled.div({
  marginTop: 20
})

// const SelectContainer = styled.div({
//   marginTop: 12
// })

const InnerContainer = styled(PerfectScrollbar)({
  width: '100%',
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '20px 30px',
})

const PhotosContainer = styled.div({
  marginTop: 30,
  marginLeft: -2,
})

class VerifyPage extends Component {

  state = {
    selected: [],
    searchItems: [],
    shown: true
  }

  handleSelect = (selected) => {
    if (this.state.selected.includes(selected)) {
      this.setState({ selected: [] })
    } else {
      this.setState({ selected: [selected] })
    }
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.closePanel() }, 300)
  }

  openVerificationPanel = () => {
    const { history, match } = this.props
    history.push({
      pathname: `${match.url}/verify/person/${this.state.selected[0].uuid}`,
    })
  }

  handleSearch = (item) => {
    const { searchItems } = this.state
    if (!searchItems.find(s => s.uuid === item.uuid)) {
      this.setState({ searchItems: searchItems.concat(item) })
    }
  }

  render = () => {
    const { data: { persons, loading } } = this.props
    const { selected, searchItems, shown } = this.state
    const personsItems = searchItems.length > 0 ? searchItems : (persons ? persons.items.filter(item => item.descriptors.length > 0) : [])
    const btnText = selected.length === 0
      ? 'Nothing selected'
      : `by ${selected[0].uuid}`
    return (
      $(AnimatedContainer, { shown },
        $(InnerContainer,
          $(HeaderRow, {
            label: 'Verification',
            onLabelClick: this.close,
            clickable: true,
            withArrow: true
          }),
          $(InputContainer, $(PanelSearchInput, { targetType: 'person', onChange: this.handleSearch })),
          // $(SelectContainer,
          //   $(Select, {
          //     value,
          //     options,
          //     onChange: noop,
          //     width: '100%',
          //     bgColor: 'var(--white)',
          //     clearable: false,
          //     searchable: false
          //   }),
          // ),
          $(PhotosContainer,
            loading
              ? $(Loader)
              : $(PhotoListSelector, {
                  items: personsItems,
                  personMode: true,
                  selected,
                  onSelect: this.handleSelect,
                }),
          ),
        ),
        $(FlatButton, {
          onClick: selected.length > 0 ? this.openVerificationPanel : noop,
          disabled: selected.length === 0,
          text: 'Verify',
          valueText: btnText
        }),
      )
    )
  }
}

export default withRouter(graphql(PERSONS, {
  options: {
    fetchPolicy: 'cache-and-network'
  }
})(VerifyPage))



// WEBPACK FOOTER //
// ./src/components/panels/VerifyPanel.js